import { Injectable, Injector } from "@angular/core";
import { StateService, Tracker } from "flux-core";
import { PlanModel, UserLocator, UserPlanPermManager } from "flux-user";
import { Observable } from "rxjs";
import { distinctUntilChanged, filter, map, switchMap, take } from "rxjs/operators";
import { DiagramLocatorLocator } from "../diagram/locator/diagram-locator-locator";

/**
 * Diagram Plan permission manager. This will handle things
 * Related to diagram plan permission
 * 
 * @author  sajeevah
 * @since   2025-08-18
 */
@Injectable()
export class DiagramPlanPermManager extends UserPlanPermManager {

    constructor(
        protected userLocator: UserLocator,
        protected injector: Injector,
        protected state: StateService<any, any>,
        protected ll: DiagramLocatorLocator,
    ) {
        super( userLocator, injector );
        if ( new.target === DiagramPlanPermManager ) {
            this.setCurrentPlan();
        }
    }

    protected diagramPlanSubscription(): Observable<PlanModel | undefined> {
        return this.state.changes( 'CurrentDiagram' ).pipe(
            distinctUntilChanged(),
            switchMap( diagId => this.ll.forDiagram( diagId, false ).getDiagramModel().pipe( take( 1 ))),
            filter( diagram => !!diagram ),
            map( diagram => {
                const purchaseInfo = (diagram as any).purchaseInfo;
                this.isPaidCanceledDiagramSub.next( purchaseInfo && !purchaseInfo.isActive );
                return diagram.plan;
            }),
        );
    }

    /**
     * Set current plan base on user subscription
     */
    protected setCurrentPlan() {
        this.diagramPlanSubscription().pipe(
            distinctUntilChanged(),
            filter( plan => !!plan ),
        ).subscribe( plan => {
            this.planId = plan.id;
            this.planType = plan.type;
            this.permissions = plan.permissions;
            this.isPaidDiagramSub.next( this.planType.includes( 'DIAGRAM' ));
            Tracker.setGlobalProperty( 'plan', this.planType );
        });
    }
    
}